import { ServiceCodeActionTypes } from './../constants/ApiConstants';
// import { extractDataFromObject } from './../../../../src/actions/utilAction';


const initialState = {
  loading: false,
  loadingDetails: false,
  master_data: [],
  serviceCodes: [],
  serviceCodeData: {},
  serviceCodeDetails: null,
};
export default (state = initialState, { type, payload }) => {
  switch (type) {
  case ServiceCodeActionTypes.get_master_data.REQUEST:  
  case ServiceCodeActionTypes.get_service_codes.REQUEST:
  case ServiceCodeActionTypes.get_ServiceCode_BySeachText.REQUEST:
  case ServiceCodeActionTypes.delete_service_code.REQUEST:
  case ServiceCodeActionTypes.post_service_code.REQUEST:
    return {
      ...state,
      loading: true,
    };


  case ServiceCodeActionTypes.get_master_data.SUCCESS:
    return {
      ...state,
      master_data: payload,
      loading: false,
    };
  case ServiceCodeActionTypes.get_service_codes.SUCCESS:
    return {
      ...state,
      serviceCodes: payload,
      loading: false,
    };
  case ServiceCodeActionTypes.get_ServiceCode_BySeachText.SUCCESS:
    return {
      ...state,
      serviceCodes: payload,
      loading: false,
    };
  case ServiceCodeActionTypes.post_service_code.SUCCESS:
    return {
      ...state,
      serviceCodeData: payload,
      loading: false,
    };
  case ServiceCodeActionTypes.delete_service_code.SUCCESS:
    return {
      ...state,
      serviceCodeData: payload,
      loading: false,
    };
  case ServiceCodeActionTypes.get_masterservicecode_by_Id.REQUEST:
    return {
      ...state,
      loadingDetails: true,
      serviceCodeDetails: null,
    };
  case ServiceCodeActionTypes.get_masterservicecode_by_Id.SUCCESS:
    return {
      ...state,
      loadingDetails: false,
      serviceCodeDetails: payload,
    };
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/Masters/components/serviceCode/reducers/ServiceCodeReducer.js